import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteProps } from './types';

import AutocompleteHookForm from './AutocompleteHookForm';
import AutocompleteBase from './AutocompleteBase';

const Autocomplete = forwardRef<HTMLDivElement, AutocompleteProps>(
  (props, ref) => {
    const formContext = useFormContext();
    const fwdRef = ref as React.Ref<HTMLDivElement>;

    if (formContext)
      return (
        <AutocompleteHookForm
          ref={fwdRef}
          formContext={formContext}
          {...props}
        />
      );

    return <AutocompleteBase ref={fwdRef} {...props} />;
  },
);

export default Autocomplete;
